<template>
  <div class="content">
    <v-chart class="chart"
             :autoresize="true"
             :option="option" />
  </div>
</template>

<script setup lang="ts">
import {
  AXIOSKEY
} from '@/core'
import { LineChart } from 'echarts/charts'
import BigNumber from "bignumber.js"
import {
  GridComponent,
  LegendComponent,
  TitleComponent,
  TooltipComponent
} from 'echarts/components'
import * as echarts from 'echarts/core'
import { UniversalTransition } from 'echarts/features'
import { CanvasRenderer } from 'echarts/renderers'
import { inject, onMounted, reactive, ref } from 'vue'
import VChart from 'vue-echarts'
import { useI18n } from 'vue-i18n'
const { t } = useI18n()
const axios = inject(AXIOSKEY)

interface ConsumptionTrends {
  time: Array<string>,
  amount: Array<string>
}

const echartsConsumptionTrends = reactive<ConsumptionTrends>({
  time: [],
  amount: []
})

echarts.use([
  TitleComponent,
  TooltipComponent,
  GridComponent,
  LegendComponent,
  LineChart,
  CanvasRenderer,
  UniversalTransition
])

const option = ref()

onMounted(() => {
  getConsumptionTrends()
})

const getConsumptionTrends = async () => {
  let temp: any = []
  const echartTemp = echartsConsumptionTrends
  await axios?.get('v1/api/bms/bill_overview').then((res: any) => {
    // 数据统计
    res.forEach((r: any) => {
      r.createdAt = r.createdAt.split('-').splice(0, 2).join('-')
      temp.push(r.createdAt)
    })
    temp = new Set(temp.sort())
    temp.forEach((r: any) => {
      let num = '0'
      res.forEach((c: any) => {
        const decimal = c.amount.split('.')[1]?.length
        if (r === c.createdAt)
          if (decimal) {
            num = ((new BigNumber(num).times(new BigNumber(10).pow(decimal))).plus(new BigNumber(c.amount).times(new BigNumber(10).pow(decimal))).div(new BigNumber(10).pow(decimal))).toFixed(2)
            // num = Number(((num * Math.pow(10, decimal) + Math.pow(10, decimal) * Number(c.amount)) / Math.pow(10, decimal)).toFixed(2))
          } else {
            num = new BigNumber(num).plus(new BigNumber(c.amount)).toFixed(2)
          }
      })
      echartTemp.time.push(r)
      echartTemp.amount.push(num)
    })
    // 补月份
    if (echartTemp.time.length < 12) {
      for (let index = echartTemp.time.length; index < 12; index++) {
        if (echartTemp.time[0]) {
          const temp: any = echartTemp.time[0].split('-')
          temp[0] = Number(temp[0])
          temp[1] = Number(temp[1]) - 1
          if (temp[1] === 0) {
            temp[0]--
            temp[1] = 12
          }
          temp[0] = temp[0].toString()
          temp[1] = temp[1].toString()
          if (Number(temp[1]) < 10) temp[1] = '0' + temp[1]
          echartTemp.time.unshift(temp.join('-'))
          echartTemp.amount.unshift('0.00')
        }
      }
    }
    createEchartOption()
  })
}

const createEchartOption = () => {

  option.value = {
    title: [{
      text: t('financial.FinancialOverview.title'),
    }, {
      text: `${t('financial.FinancialOverview.unit')}：${t('financial.FinancialOverview.yuan')}`,
      top: 30,
      textStyle: {
        fontFamily: 'Microsoft YaHei',
        fontBold: 'true',
        fontWeight: '400',
        fontSize: 14,
      }
    }
    ],
    tooltip: {
      trigger: 'item'
    },
    legend: {
      data: [t('financial.FinancialOverview.consumption')],
      right: 50
    },
    xAxis: {
      type: 'category',
      boundaryGap: false,
      data: echartsConsumptionTrends.time
    },
    yAxis: {
      type: 'value'
    },
    series: [
      {
        name: t('financial.FinancialOverview.consumption'),
        type: 'line',
        smooth: true,
        stack: 'Total',
        data: echartsConsumptionTrends.amount,
        tooltip: {
          formatter: '{c0}'
        },
        label: {
          show: true,
          function(params: any) {
            return params.toFixed(2)
          }
        },
        areaStyle: {
          color: {
            type: 'linear',
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              {
                offset: 0,
                color: '#eaeef8'
              },
              {
                offset: 1,
                color: '#002FA700'
              }
            ]
          }
        },
      }
    ]
  }
}
</script>

<style lang="less" scoped>
.content {
  width: 100%;
  height: 100%;
  padding: 24px;

  .chart {
    width: 100%;
    height: 100%;
  }
}
</style>
